export var regExpPhone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
export var regExpMail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,10}$/;
export var regExpPassword = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
export var regexpInt = /^\d{1,}$/;
export var regexpDecimal = /^\d+([,|.]\d{1,2})?$/;
export var regexpAlphanumeric = /^[a-zA-Z0-9_]*$/;
export var regExpReferenceWarehouse = /^[A-Z0-9-]{1,100}$/;
export var regexpHsCode = /^(\d{4}|\d{6}|\d{8}|\d{10})$/;
export var regexpTtb = /^\s*\d{14}(\D+.*)?$/;
export var regexpConsulantCode = /^\s*\S{6,}\s*$/;
export var regexbAbsoluteUri = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;